import { render, staticRenderFns } from "./KategoriPenyaluranPopup.vue?vue&type=template&id=acc2ec6a"
import script from "./KategoriPenyaluranPopup.vue?vue&type=script&lang=js"
export * from "./KategoriPenyaluranPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports